import React, { useState, useRef, useEffect } from "react";
import { FiArrowDownRight } from "react-icons/fi";
import { NavLink } from "react-router-dom";
import ReactParallaxTilt from "react-parallax-tilt";

const ProjectCard = ({ projectName, details, handleProjectSelect }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
  const detailsRef = useRef(null);

  useEffect(() => {
    if (detailsRef.current) {
      setIsOverflowing(
        detailsRef.current.scrollHeight > detailsRef.current.clientHeight
      );
    }
  }, [details]);

  const handleMouseMove = (e) => {
    const rect = detailsRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    // console.log("Rect:", rect.left, rect.top);
    // console.log("Cursor Position:", x, y);
    setCursorPosition({ x, y });
  };

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const renderReadButton = () => {
    if (isOverflowing) {
      return (
        <button
          onClick={toggleExpand}
          className="text-indigo-600 text-left font-semibold mt-2"
        >
          {isExpanded ? "Read Less" : "... Read More"}
        </button>
      );
    }
    return null;
  };

  return (
    <ReactParallaxTilt
      tiltMaxAngleX={10}
      tiltMaxAngleY={10}
      className="relative  mouse-cursor-gradient-tracking shadow p-3 max-w-[400px] rounded-2xl  flex-grow flex flex-col   min-w-[260px] border border-gray-400 bg-gradient-to-tl  "
    >
      <span onMouseMove={handleMouseMove}>
        <div className="font-poppins font-bold">{projectName}</div>

        <p
          ref={detailsRef}
          className={`text-pretty z-20 flex-grow overflow-hidden ${
            isExpanded ? "h-fit" : "h-36"
          }`}
        >
          {details}
        </p>
        {renderReadButton()}
        <div className="absolute bottom-0 left-0 w-full h-8 "></div>
        <div className="flex justify-center items-center">
          <NavLink
            to={`/projects/${projectName}`}
            className="px-3 flex gap-1 z-50 justify-center items-center py-2 bg-indigo-600 rounded-full
           shadow-2xl text-white text-center font-barlow font-bold text-base cursor-pointer outline-none select-none focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 hover:shadow-indigo-400 transition-all duration-300 hover:scale-105"
          >
            Discover {projectName} <FiArrowDownRight className="text-xl" />
          </NavLink>
        </div>
      </span>
    </ReactParallaxTilt>
  );
};

export default ProjectCard;
